import { NavLink } from 'react-router-dom';
import { LayoutGrid, Table2, Activity, ExternalLink, Upload, FileText } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavEntry {
  to: string;
  label: string;
  icon: typeof LayoutGrid;
  end?: boolean;
}

const NAV: NavEntry[] = [
  { to: '/', label: 'Product Map', icon: LayoutGrid, end: true },
  { to: '/table', label: 'Price List', icon: Table2 },
  { to: '/reports', label: 'Báo cáo', icon: FileText },
  { to: '/admin/import', label: 'Import CSV', icon: Upload },
];

export interface AppSidebarProps {
  className?: string;
}

/**
 * Responsive sidebar:
 * - Desktop (lg ≥ 1024px): full width 240px with text labels
 * - Tablet (md 768-1023px): collapsed to 64px icon-only
 * - Mobile (< 768px): hidden — BottomNav takes over
 */
export function AppSidebar({ className }: AppSidebarProps) {
  return (
    <aside
      className={cn(
        'flex w-16 shrink-0 flex-col gap-6 border-r bg-card px-2 py-6 transition-all',
        'lg:w-60 lg:px-4',
        className
      )}
    >
      <div className="px-1 lg:px-2">
        <div className="text-base font-bold tracking-tight">
          <span className="text-primary">G</span>
          <span className="hidden lg:inline">
            <span className="text-primary">earVN</span>
            <span className="text-muted-foreground"> · Monitor</span>
          </span>
        </div>
        <div className="mt-1 hidden text-xs text-muted-foreground lg:block">Internal dashboard</div>
      </div>

      <nav className="flex flex-col gap-0.5">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            title={item.label}
            className={({ isActive }) =>
              cn(
                'flex min-h-[44px] items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                'justify-center lg:justify-start',
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
              )
            }
          >
            <item.icon className="h-4 w-4 shrink-0" />
            <span className="hidden lg:inline">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="flex flex-col gap-2">
        <div className="hidden px-3 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground lg:block">
          Tools
        </div>
        <a
          href="/test"
          target="_blank"
          rel="noreferrer"
          title="API Smoke Test"
          className={cn(
            'flex min-h-[44px] items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground',
            'justify-center lg:justify-start'
          )}
        >
          <Activity className="h-4 w-4 shrink-0" />
          <span className="hidden lg:inline">API Smoke Test</span>
          <ExternalLink className="ml-auto hidden h-3 w-3 lg:inline" />
        </a>
      </div>

      <div className="mt-auto hidden px-3 text-[11px] leading-tight text-muted-foreground lg:block">
        v0.1.0 · D1 + Pages
      </div>
    </aside>
  );
}
